import instance from '../index';
const RESOURCE_PAYMENT_METHOD = 'stripe';

export const PaymentMethodApi = {
  /**
   * Create a Stripe setup intent for a client
   * @returns {Promise<Object>} Setup intent details
   * @property {string} client_secret - Client secret for the setup intent
   * @property {string} id - ID of the setup intent
   * @property {string} status - Status of the setup intent
   */
  createSetupIntent() {
    return instance.post(`/${RESOURCE_PAYMENT_METHOD}/create-setup-intent`);
  },

  /**
   * Save a Stripe payment method for a client
   * @param {string} paymentMethodId - ID of the payment method to save
   * @param {Object} payload - Payload containing payment method details
   * @returns {Promise<Object>} Saved payment method details
   * @property {Object} paymentMethod - Payment method details
   */
  savePaymentMethod(paymentMethodId) {
    return instance.post(`/${RESOURCE_PAYMENT_METHOD}/payment-method`, {
      payment_method_id: paymentMethodId
    });
  },

  /**
   * Retrieve  Stripe payment methods
   * @returns {Promise<Object>} Retrieved payment methods list
   */
  getPaymentMethods() {
    return instance.get(`/${RESOURCE_PAYMENT_METHOD}/payment-methods`);
  },

  /**
   * Delete Stripe payment method
   * @returns {Promise<Object>} Retrieved payment methods list
   */
  deletePaymentMethod(id) {
    return instance.delete(`/${RESOURCE_PAYMENT_METHOD}/payment-methods/${id}`);
  },

  /**
   * Set default Stripe payment method
   * @returns {Promise<Object>} Retrieved payment methods list
   */
  setDefaultPaymentMethod(id) {
    return instance.patch(`/${RESOURCE_PAYMENT_METHOD}/payment-methods/default/${id}`);
  }
};
